import researcherConfidentialTemplateService from '../services/templates/researcher_confidential_template.service';
import CreateFileTemplatePage from './CreateFileTemplatePage';
const ResearcherConfidentialTemplatePage = CreateFileTemplatePage({
  service: researcherConfidentialTemplateService,
  templateType: 'researcher_confidential_template',
  fileType: 'xlsx'
});
export default ResearcherConfidentialTemplatePage;